import { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import { JoinModal } from 'features/paid-membership/JoinModal';
import Button from 'honeydew/Button';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { getCartMemberSavings, getGroceryMinMet } from 'utils/priceUtils';

function PlusMembershipProspectBanner({ hide, intersectionRef, sticky }) {
    const [modalOpen, setModalOpen] = useState(false);

    const { data: account = {} } = useAccountQuery();
    const { data: selections = {} } = useSelectionsQuery();
    const { availableTrialMembership, plusMembershipBranding } = useAccountPlusMembershipHook();

    const groceryMinMet = getGroceryMinMet({ account, selections });
    const cartMemberSavings = getCartMemberSavings({ account, selections });

    if (!groceryMinMet || cartMemberSavings <= 0) {
        return false;
    }

    function handleClick(e) {
        if (e.type !== 'keydown' || e.code === 'Enter' || e.key === 'Enter' || e.keyCode === 13) {
            setModalOpen(true);
        }
    }

    const bannerContent = (
        <div
            className="flex items-center gap-10 bg-plus-membership-gradient p-10"
            onClick={handleClick}
            onKeyDown={handleClick}
            role="button"
            tabIndex={0}
        >
            <p className="text-body-sm !leading-[20px]">
                <span className="text-body-sm block font-grotesk-bold">Save up to $24.76 a month</span>
                <span className="text-body-xs">on avg. when shopping weekly with {plusMembershipBranding}</span>
            </p>
            <div className="ml-auto shrink-0">
                <Button size="sm" variant="plusMembership" as="span">
                    {availableTrialMembership ? 'Try it free' : 'Join'}
                </Button>
            </div>
        </div>
    );

    if (sticky) {
        return (
            <div className={clsx('z-10', hide ? 'overflow-hidden' : 'sticky bottom-0')}>
                <div className={clsx('transition', hide ? 'translate-y-full' : 'translate-y-0')}>
                    {bannerContent}
                    <JoinModal onClose={() => setModalOpen(false)} open={modalOpen} />
                </div>
            </div>
        );
    }

    return (
        <div ref={intersectionRef} className="mt-10 overflow-hidden rounded-lg">
            {bannerContent}
            <JoinModal onClose={() => setModalOpen(false)} open={modalOpen} />
        </div>
    );
}

PlusMembershipProspectBanner.propTypes = {
    hide: PropTypes.bool,
    intersectionRef: PropTypes.shape({}),
    sticky: PropTypes.bool,
};

PlusMembershipProspectBanner.defaultProps = {
    hide: false,
    intersectionRef: undefined,
    sticky: false,
};

export { PlusMembershipProspectBanner };
